<template>
  <div id="email-verify">
    <div class="alert -danger" v-if="errors.unrecognized">
      <p class="title">Ops!</p>

      <p>Ocorreu um erro ao verificar seu email, tente novamente.</p>
    </div>

    <loader
      background="#FFF"
      v-if="loading"/>
  </div>
</template>

<script>
import { mask } from 'vue-the-mask';
import Loader from '@/support/components/Loader.vue';

export default {
  name: 'EmailVerify',

  data() {
    return {
      loading: false,

      errors: {
        unrecognized: false,
      },
    };
  },

  methods: {
    /**
     * Verify the email.
     *
     * @returns {Promise<void>}
     */
    async verifyEmail() {
      try {
        this.loading = true;
        this.resetErrors();

        await this.$store.dispatch('auth/verifyEmail', {
          firstToken: this.$route.params.firstToken,
          secondToken: this.$route.params.secondToken,
          expires: this.$route.query.expires,
          signature: this.$route.query.signature,
        });

        this.$router.push({ name: 'Auth-Login' });
      } catch (err) {
        this.errors.unrecognized = true;
      } finally {
        this.loading = false;
      }
    },

    /**
     * Reset the errors page.
     */
    resetErrors() {
      this.errors.unrecognized = false;
    },
  },

  mounted() {
    this.verifyEmail();
  },

  computed: {
  },

  directives: {
    mask,
  },

  components: {
    Loader,
  },
};
</script>

<style lang="scss" scoped>
  #email-verify {
    @apply relative;
  }
</style>
